import { LAW_INTERFACE } from '../constants/localStorageNames';
import { LawInterfacesEnum } from '../enums/LawInterfacesEnum';

export function getLawInterfaceFromStorage(): LawInterfacesEnum {
  const lawInterface: LawInterfacesEnum | null = localStorage.getItem(LAW_INTERFACE) as LawInterfacesEnum | null;

  return lawInterface ?? LawInterfacesEnum.FZ_294;
}
